import React from "react";
import { Link } from "gatsby";

function Listing() {
  return (
    <div className="press_section">
      <div className="container">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
            <div className="example" data-text="Popular topics">
              <h2>Popular topics</h2>
            </div>
            <div className="press_grid">
              <div className="blog_item">
                <div className="content_blog">
                  <h4>Node.js</h4>
                  <p>How to Hire the Right Node.js Developer?</p>
                  <Link to="/press-release">Read More</Link>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>ZAWYA</h4>
                  <p>Tekrevol resumes its journey of revolution in MENA</p>
                  <a
                    href="https://www.zawya.com/en/press-release/tekrevol-resumes-its-journey-of-revolution-in-mena-p9ubqxxn"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>BUSINESS.COM</h4>
                  <p>
                    "If they say they can do everything, it is a bad sign..."
                    Abeer talks about red flags to watch out for when
                    freelancing.
                  </p>
                  <a
                    href="https://www.business.com/articles/benefits-and-risks-of-hiring-freelancers/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>TWITTER</h4>
                  <p>
                    Featured on the "Top Game Development Companies In the
                    Industry"
                  </p>
                  <a
                    href="https://twitter.com/GoodFirms/status/1127793856718577664"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>GOOD FIRMS</h4>
                  <p>
                    Featured on the "List of Top Companies for Game Development"
                  </p>
                  <a
                    href="https://www.goodfirms.co/game-development-companies"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>FORBES</h4>
                  <p>
                    Tekrevol addresses five unique ways to attract investors
                  </p>
                  <a
                    href="https://www.forbes.com/sites/theyec/2019/05/16/attracting-investors-five-approaches-you-can-use/?sh=a25bb23e559e"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>FORBES</h4>
                  <p>Abeer helps new entrepreneurs overcome their concerns</p>
                  <a
                    href="https://www.forbes.com/sites/theyec/2019/05/02/new-business-new-worries-seven-concerns-entrepreneurs-overcame-when-they-first-started-out/?sh=23951930390c"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>FXDAILYREPORT</h4>
                  <p>Evaluation strategies by successful entrepreneurs</p>
                  <a
                    href="https://fxdailyreport.com/evaluation-strategies-successful-entrepreneurs-part-1/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>GOOD FIRMS</h4>
                  <p>
                    The groundbreaking role of mobile app development in the VR
                    market
                  </p>
                  <a
                    href="https://www.goodfirms.co/blog/what-mobile-app-development-has-to-offer-vr-market"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>THRIVEGLOBAL</h4>
                  <p>Tips to rebalance your mind and move ahead</p>
                  <a
                    href="https://community.thriveglobal.com/when-everything-is-going-wrong-try-these-10-tips-to-rebalance-your-mind/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>EINPRESSWIRE</h4>
                  <p>
                    Featured as one of the "Top Custom Software Development
                    Companies in the USA"
                  </p>
                  <a
                    href="https://www.einpresswire.com/article/488949089/goodfirms-features-the-new-list-of-best-software-developers-in-the-usa-for-june-2019"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>TOP DEVELOPERS</h4>
                  <p>
                    Interview with Co-founder and CTO of TekRevol - Asim Rais
                    Siddiqui
                  </p>
                  <a
                    href="https://www.topdevelopers.co/profile/tekrevol/69/interview-Asim-Rais-Siddiqui"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>FORBES</h4>
                  <p>
                    Our leaders talk about how to keep your cool during a
                    company crisis
                  </p>
                  <a
                    href="https://www.forbes.com/sites/theyec/2019/06/28/10-ways-leaders-can-keep-their-cool-during-a-company-crisis/?sh=3ec7f7477dac"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>BUSINESS.COM</h4>
                  <p>
                    Pick the online meeting software that works best for your
                    firm
                  </p>
                  <a
                    href="https://www.business.com/articles/7-powerful-tips-for-highly-productive-online-meetings/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>FORBES</h4>
                  <p>
                    Attract consumers by providing the information they want
                  </p>
                  <a
                    href="https://www.forbes.com/sites/theyec/2019/06/26/review-platforms-how-to-attract-consumers-by-providing-the-information-they-want/?sh=7a402b3dc48a"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>CMSWIRE</h4>
                  <p>
                    "A fractional CTO can add more value strategically..." -
                    Asim Rais Siddiqui
                  </p>
                  <a
                    href="https://www.cmswire.com/digital-workplace/the-pros-and-cons-of-hiring-a-fractional-cto/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>THE NEXT WEB</h4>
                  <p>
                    AI technologies are spreading at a rapid pace into a variety
                    of businesses & job types
                  </p>
                  <a
                    href="https://thenextweb.com/news/developing-approaches-8-industries-ai-could-impact-next"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>FORBES</h4>
                  <p>
                    "The goal is to change the way people think about your brand
                    and its values." - Abeer Raza
                  </p>
                  <a
                    href="https://www.forbes.com/sites/theyec/2019/07/16/embracing-the-human-element-how-modern-businesses-can-commit-to-corporate-social-responsibility/?sh=1f7d77a94e3b"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>GOOD FIRMS</h4>
                  <p>
                    "Tekrevol LLC is a Silicon Valley startup" - Asim Rais
                    Siddiqui Interviewed by GoodFirms
                  </p>
                  <a
                    href="https://www.goodfirms.co/company/tekrevol"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read More
                  </a>
                </div>
              </div>
              <div className="blog_item">
                <div className="content_blog">
                  <h4>FORBES</h4>
                  <p>
                    IoT Growth and Security - predictions from industry leaders
                  </p>
                  <a
                    href="https://www.forbes.com/sites/theyec/2019/07/22/iot-growth-and-security-12-predictions-on-whats-ahead/?sh=672108922e05"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read More
                  </a>
                </div>
              </div>
              {/* <div className="blog_item">
                <div className="content_blog">
                  <h4>THE NEXT WEB</h4>
                  <p>
                    Advice for aspiring entrepreneurs on navigating the startup
                    world
                  </p>
                  <a
                    href="https://thenextweb.com/news/advice-for-aspiring-entrepreneurs-on-navigating-the-startup-world"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Read More
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Listing;
